import { render, staticRenderFns } from "./HotListPage.vue?vue&type=template&id=2a3fe0d7&scoped=true"
import script from "./HotListPage.vue?vue&type=script&lang=js"
export * from "./HotListPage.vue?vue&type=script&lang=js"
import style0 from "./HotListPage.vue?vue&type=style&index=0&id=2a3fe0d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3fe0d7",
  null
  
)

export default component.exports